import React from "react";
import { RadarSpinner } from "react-epic-spinners";

function PaymentSuccess({ refference, title, func }) {
  return (
    <div className="flex flex-col p-3 gap-5 items-center space-x-2 ">
      <RadarSpinner size={50} color="#202030" />
      <p className="text-center">
        PAYMENT FOR <span className="font-bold">{title}</span> RECEIVED
        SUCCESSFULLY
      </p>
      <p className="text-lg text-green-700 uppercase">{refference}</p>
      <button
        type="button"
        className="text-yellow-900 bg-yellow-400 opacity-80 hover:bg-yellow-300 focus:ring-3 focus:outline-none focus:ring-yellow-800 font-medium rounded-2xl text-sm w-full sm:w-auto px-5 py-2.5 text-center"
        onClick={func}
      >
        Done
      </button>
    </div>
  );
}

export default PaymentSuccess;
